import type { Commune, Region } from '@/modules/region/domain/Region';
import type { QueryHook } from '@/sections/shared/types/QueryHook';

import useRegions from './useRegions';

const useCommunes = (id: Region['id']): QueryHook<Commune[]> => {
  const { data, isLoading, error } = useRegions();
  return {
    data: data.find((region) => region.id === id)?.communes || [],
    isLoading,
    error
  };
};

export default useCommunes;
